import { render, staticRenderFns } from "./LayoutAdminContentDefault.vue?vue&type=template&id=c423960e"
var script = {}
import style0 from "./LayoutAdminContentDefault.vue?vue&type=style&index=0&id=c423960e&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports